import {backAdmin} from "../axios";

export const connectionsApi = [
    {url: `${backAdmin}/connections`, name: 'connections.all', method: 'GET'},
    {url: `${backAdmin}/connections/{id}/return`, name: 'connections.return', method: 'PUT'},
    {url: `${backAdmin}/connections/export`, name: 'connections.export', method: 'GET'},
]